export default "__VITE_ASSET__E9A$jiWI__"